import React from 'react';
import SessionTimeOut from 'components/sessionTimeOut/SessionTimeOut';

export const useSessionTimeOutRender = () => {
    const renderSessionTimeout = () => {
        // eslint-disable-next-line no-undef
        if (__ENV__ === 'LOCAL') {
            return null;
        }

        return <SessionTimeOut />;
    };

    return { renderSessionTimeout };
};
